import { render, staticRenderFns } from "./new-property-list-item.vue?vue&type=template&id=5630e794"
import script from "./new-property-list-item.vue?vue&type=script&lang=js"
export * from "./new-property-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports